var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.005,
    height: 16.501,
    viewBox: "0 0 18.005 16.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_43174",
    "data-name": "\\u7EC4 43174",
    transform: "translate(7014 20692.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_537",
    "data-name": "\\u8DEF\\u5F84 537",
    className: "cls-1",
    d: "M.63,4.46A.633.633,0,0,0,0,5.092V11.22a3.755,3.755,0,0,0,3.751,3.751h10.5A3.756,3.756,0,0,0,18,11.22v-6.2a.635.635,0,0,0-.637-.634Z",
    transform: "translate(-7014 -20691.436)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_538",
    "data-name": "\\u8DEF\\u5F84 538",
    className: "cls-1",
    d: "M14.252,1.5h-4.9l-.351-.084L6.653.237a2.233,2.233,0,0,0-1-.237h-1.9A3.751,3.751,0,0,0,0,3.751v.107a.635.635,0,0,0,.637.634l16.356-.082a.63.63,0,0,0,.575-.9A3.75,3.75,0,0,0,14.252,1.5",
    transform: "translate(-7014 -20692.965)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.a7263372435e846de9fe3b0474425b91.svg";
export { ForwardRef as ReactComponent };